import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import * as React from 'react';
import PropTypes from 'prop-types';
import useTranslate from '../../hooks/useTranslate';

var I18n = function I18n(_ref) {
  var ns = _ref.ns,
      children = _ref.children,
      options = _ref.options;

  var _options$wait = options.wait,
      wait = _options$wait === void 0 ? false : _options$wait,
      _options = _objectWithoutProperties(options, ["wait"]);

  var _useTranslate = useTranslate(ns, _options),
      __ = _useTranslate.__,
      i18n = _useTranslate.i18n,
      ready = _useTranslate.ready;

  if (!ready && wait) {
    return null;
  }

  return children(__, i18n);
};

I18n.defaultProps = {
  ns: undefined,
  options: Object.freeze({})
};
I18n.propTypes = {
  ns: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  children: PropTypes.func.isRequired,
  options: PropTypes.shape({
    wait: PropTypes.bool,
    nsMode: PropTypes.oneOf(['default', 'fallback']),
    bindI18n: PropTypes.arrayOf(PropTypes.oneOf(['initialized', 'loaded', 'failedLoading', 'missingKey', 'added', 'removed', 'languageChanged'])),
    bindStore: PropTypes.arrayOf(PropTypes.oneOf(['added', 'removed']))
  })
};
export default I18n;